import * as yup from 'yup'

export const POSValidation = yup.object().shape({
  branch_id: yup.number().required(),
  name: yup.string().required()
})